/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useT } from 'talkr';
import s from './index.module.scss';
import bg2 from './img/short_2.jpg';
import ActionBar from '../../components/actionBar';

function WhatWeHaveForYou() {
  const { T } = useT();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: 'IS_STATUSBAR_TRANSPARENT',
      payload: true,
    });
  });

  return (
    <div className={s.whatWeHaveForYou}>
      <div className={s.whatWeHaveForYou_text}>
        <div
          className={s.whatWeHaveForYou_description}
          dangerouslySetInnerHTML={{ __html: T('whatWeHaveForYou_description') }} 
        />
      </div>
      <img className={s.whatWeHaveForYou_bg} src={bg2} alt={s.welcome} />
      <div className={s.whatWeHaveForYou_shadow} />
      <ActionBar currentStepCompleted show transparentBg />
    </div>
  );
}

export default WhatWeHaveForYou;
